import React from 'react';
import PropTypes from 'prop-types';

import './css_spinner.css';

const Spinner = props => {
  const { injectStyles } = props;
  // set default styles
  if (!injectStyles.width) injectStyles.width = '38px';
  if (!injectStyles.height) injectStyles.height = '38px';
  if (!injectStyles.zIndex) injectStyles.zIndex = 900;
  if (!injectStyles.left && !injectStyles.right)
    injectStyles.left = 'calc(50% - 19px)';
  if (!injectStyles.top) injectStyles.top = 'calc(50% - 19px)';
  if (!injectStyles.position) injectStyles.position = 'absolute';
  return (
    <div id="floatingCirclesG" style={injectStyles}>
      <div className="f_circleG" id="frotateG_01" />
      <div className="f_circleG" id="frotateG_02" />
      <div className="f_circleG" id="frotateG_03" />
      <div className="f_circleG" id="frotateG_04" />
      <div className="f_circleG" id="frotateG_05" />
      <div className="f_circleG" id="frotateG_06" />
      <div className="f_circleG" id="frotateG_07" />
      <div className="f_circleG" id="frotateG_08" />
    </div>
  );
};

Spinner.defaultProps = {
  injectStyles: {},
};

Spinner.propTypes = {
  injectStyles: PropTypes.object,
};

export default Spinner;
